export enum KB_FOOD_CATEGORY {
  F01 = '간이주점',
  F02 = '기타외국식',
  F03 = '떡/한과',
  F04 = '분식',
  F05 = '휴게소/구내식당',
  F06 = '뷔페',
  F07 = '양식',
  F08 = '유흥주점',
  F09 = '음식배달서비스',
  F10 = '일식',
  F11 = '제과/제빵',
  F12 = '중식',
  F13 = '출장 및 이동음식업',
  F14 = '커피/음료',
  F15 = '패스트푸드',
  F16 = '한식',
}
export const CONST_KB_FOOD_CATEGORY = Object.values(KB_FOOD_CATEGORY);
